export const getCurrentFocus = (state) => state.getIn(['app', 'currentFocus', 'section']);
